<template>
    <v-popover :open.sync="opened" popoverInnerClass="add-action-popover">

        <slot name="popover-trigger"></slot>

        <template v-slot:popover="{ isOpen }">
            <div class="action-select-container">
                <label>
                    Action
                </label>
                <multiselect
                    v-if="isOpen"
                    :options="actions"
                    @input="onActionSelect"
                    label="name"
                    trackBy="name"
                    autofocus
                    class="action-select"/>
            </div>
        </template>
    </v-popover>
</template>

<script>
import {AutomationTypes} from '@/types/automations/types'

export default {
    name: 'AutomationActionSelect',
    inject: ['getAvailableActions'],
    props: {
        type: {
            type: String,
            required: true,
            default: AutomationTypes.AUTOMATION
        }
    },
    data() {
        return {
            opened: false
        }
    },
    methods: {
        onActionSelect(action) {
            this.$emit('select', action)
            this.opened = false
        }
    },
    computed: {
        actions() {
            return this.getAvailableActions({type: this.type})
        }
    }
}
</script>

<style scoped lang="scss">
.action-select-container,
.action-select {
    min-width: 300px;
}
</style>

<style>
.add-action-popover {
    min-width: 300px;
    padding: 8px !important;
}
</style>
